import React from "react";
import { FormattedMessage } from "react-intl";
import "../theme/styles.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer>
      <div className="footerLinks">
        <a href="/about">
          <FormattedMessage id="Footer.About" />
        </a>
        <a href="/contact">
          <FormattedMessage id="Footer.Contact" />
        </a>
        <a href="/privacy-policy">
          <FormattedMessage id="Footer.PrivacyPolicy" />
        </a>
        <a href="/terms-of-use">
          <FormattedMessage id="Footer.TermsOfUse" />
        </a>
      </div>
      <div className="copyright">
        &copy;&nbsp;
        {currentYear}
        {' '}
SeaHawk Technology Development, LLC
      </div>
    </footer>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js